var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46.09 41.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "20b66568-929b-40a3-8027-7a60be22a211",
    x1: 81.71,
    y1: 49.17,
    x2: -83.36,
    y2: -46.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#49c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4dbfef",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#57a8f1",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6784f5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7d52fa",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9321ff",
    stopOpacity: 0.6
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Isolation Mode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b7d4ea24-90ba-4005-8bb5-ed72632fb64a",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28a7aba8-4439-4cea-84c8-6f563caa6897",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.43.78A90.2,90.2,0,0,0,9.8,1.06a16.1,16.1,0,0,0-5.24,1.5C1.67,4.13-.67,8.07.18,11.34a15,15,0,0,0,2.16,4.35,99.45,99.45,0,0,0,19,21.6A22.67,22.67,0,0,0,26.81,41a9,9,0,0,0,6.44.52c3.09-1.06,5-4.11,6.43-7A68,68,0,0,0,45.76,15c.56-3.71.68-7.91-1.8-10.72C41.88,1.9,38.54,1.19,35.43.78Zm.38,14.92a33.65,33.65,0,0,1-3,9.64c-.71,1.45-1.66,3-3.19,3.49a4.44,4.44,0,0,1-3.18-.26,11.44,11.44,0,0,1-2.7-1.82,49.68,49.68,0,0,1-9.41-10.69,7.51,7.51,0,0,1-1.07-2.16,4.24,4.24,0,0,1,2.17-4.34A7.71,7.71,0,0,1,18,8.82,44.52,44.52,0,0,1,30.7,8.67a6.64,6.64,0,0,1,4.23,1.73C36.15,11.79,36.09,13.87,35.81,15.7Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#20b66568-929b-40a3-8027-7a60be22a211)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticleLogo);
export default __webpack_public_path__ + "static/media/particle-logo.715e61426779858aebe8e3f14dfae50e.svg";
export { ForwardRef as ReactComponent };